<script>
import { Line } from "vue-chartjs";
import { mapGetters } from "vuex";

export default {
  extends: Line,
  props: {
    chartData: {
      type: Array || Object,
      required: false
    },
    chartLabels: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      options: {
        id: "weight-chart",
        scales: {
          yAxes: [
            {
              ticks: {
                display: true
              },
              gridLines: {
                display: true
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false
              },
              ticks: {
                display: true
              }
            }
          ]
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: false,
          backgroundColor: "rgba(138,179,83, 0.7)",
          displayColors: true,
          position: "nearest",
          callbacks: {
            label: function(item, data) {
              var value = data.datasets[item.datasetIndex].data[item.index];

              return value + " " + data.datasets[item.datasetIndex].label;
            }
          },
          custom: function(tooltipModel) {
            let tooltipEl = null;
            if (
              tooltipModel.title &&
              ["Start", "Now", "Goal"].indexOf(tooltipModel.title[0]) !== -1
            ) {
              tooltipEl =
                document.getElementById(`${tooltipModel.title[0]}-tooltip`) ||
                document.createElement("div");
              tooltipEl.id = `${tooltipModel.title[0]}-tooltip`;
            } else {
              // Tooltip Element
              tooltipEl =
                document.getElementById("chartjs-tooltip") ||
                document.createElement("div");

              // Create element on first render
              tooltipEl.id = "chartjs-tooltip";

              // Hide if no tooltip
              if (tooltipModel.opacity === 0) {
                tooltipEl.style.opacity = 0;
                return;
              }
            }
            let outerComponent = document.getElementById("weight-chart");
            tooltipEl.innerHTML = "<table></table>";
            outerComponent.appendChild(tooltipEl);

            // Set caret Position
            tooltipEl.classList.remove("above", "below", "no-transform");
            if (tooltipModel.yAlign) {
              tooltipEl.classList.add(tooltipModel.yAlign);
            } else {
              tooltipEl.classList.add("above");
            }

            // Set Text
            if (tooltipModel.body) {
              let titleLines = tooltipModel.title || [];
              let bodyLines = tooltipModel.body.map(bodyItem => bodyItem.lines);
              let thead = document.createElement("thead");

              titleLines.forEach(function(title) {
                thead.innerHTML += `<tr><th>${title}</th></tr>`;
              });

              let tbody = document.createElement("tbody");

              bodyLines.forEach(function(body) {
                const value = body[0];

                tbody.innerHTML += `<tr><td class="flex justify-center whitespace-nowrap">${value}</td></tr>`;
              });

              let tableRoot = tooltipEl.querySelector("table");
              tableRoot.innerHTML = thead.outerHTML + tbody.outerHTML;
            }

            Object.assign(tooltipEl.style, {
              opacity: 1,
              position: "absolute",
              left: `${tooltipModel.caretX - 25}px`,
              top: `${tooltipModel.caretY - 60}px`,
              fontFamily: tooltipModel._bodyFontFamily,
              fontSize: tooltipModel.bodyFontSize + "px",
              fontStyle: tooltipModel._bodyFontStyle,
              padding: `${tooltipModel.yPadding}px ${tooltipModel.xPadding}px`,
              pointeEvents: "none",
              cursor: "default",
              backgroundColor: tooltipModel.backgroundColor,
              borderRadius: "3px"
            });
          }
        },
        layout: {
          padding: {
            right: 0
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters({ nutritionistInfo: "getNutritionistInfo" })
  },
  methods: {
    tooltipCreate() {}
  },
  mounted() {
    this.gradient = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);

    this.gradient.addColorStop(0, "rgba(138,179,83,1)");
    this.gradient.addColorStop(0.02, "rgba(180,206,145,0.98)");
    this.gradient.addColorStop(1, "rgba(255,255,255,0)");

    this.renderChart(
      {
        labels: this.chartLabels,
        datasets: [
          {
            label:
              this.nutritionistInfo.measurement_system === "metric"
                ? "kgs"
                : "lbs",
            borderColor: "#8ab353",
            pointBackgroundColor: "#8ab353",
            pointBorderWidth: 4,
            pointHoverBorderWidth: 5,
            borderWidth: 1,
            pointBorderColor: "#8ab353",
            backgroundColor: this.gradient,
            data: this.chartData
          }
        ]
      },
      this.options
    );
  },
  beforeDestroy() {
    const tooltips = ["Start", "Now", "Goal", "chart-js"];

    tooltips.forEach(tooltip => {
      const element = document.getElementById(`${tooltip}-tooltip`);
      if (element) {
        element.style.opacity = 0;
      }
    });
  }
};
</script>

<style>
/* #chartjs-tooltip,
#Now-tooltip,
#Start-tooltip,
#Goal-tooltip {
  z-index: 999;
} */

#weight-chart {
  position: relative;
}
</style>
